import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {UpmEntityType} from '@refra/modules/common/enums'
import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse, PlantNode, TreeNode, DepartmentNode} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

const selector = (plantNode: PlantNode) => {
  const kilnNodes: DepartmentNode[] = []

  const parseNode = (treeNode: TreeNode) => {
    if (treeNode.itemType === UpmEntityType.Department && treeNode.type?.name === 'Kiln') {
      kilnNodes.push(treeNode)
    }

    treeNode.children.forEach((child: TreeNode) => parseNode(child))
  }

  parseNode(plantNode)
  return kilnNodes
}

export const useKilnNodesQuery = (plantUpmId: string) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'upmPlantStructure',
    params: [{plantUpmId, IncludeEquipment: true}],
    select: selector,
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useKilnNodesQuery')
        .extras({errorDetails, plantUpmId})
        .error('Error occurred while fetching kiln nodes')

      spawnErrorToast(t('error.kilnNodes'))

      return false
    }
  })
}
